import classNames from 'classnames';
import { ForwardedRef, forwardRef, ReactElement } from 'react';

import * as styles from './Card.module.css';

type CardGenericProps = {
    index?: number;
    children: ReactElement;
    backgroundcolor?: string;
    hasboxshadow?: boolean;
    classes?: string;
    textcolor?: string;
};

const CardGeneric = forwardRef(function RefCard(
    {
        index,
        children,
        backgroundcolor = 'bg-white',
        hasboxshadow = true,
        classes,
        textcolor = 'text-black',
    }: CardGenericProps,
    ref: ForwardedRef<HTMLDivElement | null>
) {
    return (
        <div
            ref={ref}
            className={classNames(
                'card-container',
                classes?.includes("bronze-card") || classes?.includes("silver-card") || 
                classes?.includes("gold-card") || classes?.includes("platinum-card") ? 
                'bg-gray-lightest' : backgroundcolor,
                'md:h-full relative rounded-lg pb-6 px-4 md:pb-10 md:px-6',
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
                styles.cardGeneric,
                textcolor,
                classes
            )}
            style={
                hasboxshadow
                    ? { boxShadow: '0px 0px 8px 2px hsl(0deg 0% 40% / 20%)' }
                    : { boxShadow: 'none' }
            }
            data-index={index}
        >
            {children}
        </div>
    );
});

CardGeneric.displayName = 'CardGeneric';

export default CardGeneric;
